// extracted by mini-css-extract-plugin
module.exports = {"container-configuration":"SettingTimeHourDelivery_container-configuration__k4dTp"};